import { FC } from "react";
import { useTranslation } from "react-i18next";

import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Bold, Paragraph, Subheading } from "capitalrx-components-2.0/lib/typography";

import { DetailSection } from "./DetailSection";

interface DrugDetailsProps {
  quantity: string;
  drugName: string;
  daysSupply: string | number;
  dosage: string;
  dosageForm: string;
  drugType: "Brand" | "Generic";
}

export const DrugDetails: FC<DrugDetailsProps> = ({ quantity, drugName, daysSupply, dosage, dosageForm, drugType }) => {
  const { t: translate } = useTranslation();
  return (
    <div>
      <Stack spacing="small">
        <Shelf style={{ height: "36px" }}>
          <Subheading>{translate("PRICING_DETAIL_PANELS.drugDetails.prescriptionDetails")}</Subheading>
          <Shelf.Spacer />
        </Shelf>

        <DetailSection alignment="top">
          <Bold>{translate("PRICING_DETAIL_PANELS.drugDetails.name")}: </Bold>
          <Paragraph testId="drug-name">{drugName}</Paragraph>
          <Shelf.Spacer />
        </DetailSection>

        <DetailSection alignment="top">
          <Bold>{translate("PRICING_DETAIL_PANELS.drugDetails.type")}: </Bold>
          <Paragraph testId="drug-type">{drugType}</Paragraph>
          <Shelf.Spacer />
        </DetailSection>

        <DetailSection alignment="top">
          <Bold>{translate("PRICING_DETAIL_PANELS.drugDetails.quantity")}: </Bold>
          <Paragraph testId="quantity">{quantity}</Paragraph>
          <Shelf.Spacer />
        </DetailSection>

        <DetailSection alignment="top">
          <Bold>{translate("PRICING_DETAIL_PANELS.drugDetails.daysSupply")}: </Bold>
          <Paragraph testId="days-supply">{daysSupply}</Paragraph>
          <Shelf.Spacer />
        </DetailSection>

        <DetailSection alignment="top">
          <Bold>{translate("PRICING_DETAIL_PANELS.drugDetails.dosage")}: </Bold>
          <Paragraph testId="dosage">{dosage}</Paragraph>
          <Shelf.Spacer />
        </DetailSection>

        <Shelf alignment="top">
          <Bold>{translate("PRICING_DETAIL_PANELS.drugDetails.form")}: </Bold>
          <Paragraph testId="dosage-form">{dosageForm}</Paragraph>
          <Shelf.Spacer />
        </Shelf>
      </Stack>
    </div>
  );
};
